import { useState, useCallback } from 'react';
import { message } from 'antd';
import { c304Api, QueryParams, ReportRow, UnitSummary, GroupCount, CurrencySummary } from '../../../services/c304Api';

export function useC304Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [unitSummary, setUnitSummary] = useState<UnitSummary[]>([]);
  const [groupCounts, setGroupCounts] = useState<GroupCount[]>([]);
  const [currencySummary, setCurrencySummary] = useState<CurrencySummary[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await c304Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setUnitSummary(resp.unit_summary || []);
        setGroupCounts(resp.group_counts || []);
        setCurrencySummary(resp.currency_summary || []);
        setNoData(false);
      } else {
        setData([]);
        setUnitSummary([]);
        setGroupCounts([]);
        setCurrencySummary([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setUnitSummary([]);
    setGroupCounts([]);
    setCurrencySummary([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, unitSummary, groupCounts, currencySummary, queried, noData, runQuery, reset };
}
